import React, { PureComponent } from 'react';
import Select from 'react-select';

import styles from './styles';

export default class Input extends PureComponent {
  static defaultProps = {
    type: 'text'
  };
  values = {};

  handleChange = (prop) => (ev) => {
    const {onChange} = this.props;

    // Set the value
    this.values[prop] = ev.target ? ev.target.value : ev.value;

    // Extract the values after modifying them
    const {input, ...restValues} = this.values;

    onChange(input, { ...restValues });
  };

  renderPrefix(prefix, prefixValue) {

    if (Array.isArray(prefix)) {
      return (
        <Select
          className={`${styles.prefix} ${styles.select}`}
          name='prefix'
          value={prefixValue}
          options={prefix}
          onChange={this.handleChange('prefix')}
          clearable={false}
          searchable={false}
        />
      );
    }

    if (prefix) {
      return (
        <div className={`${styles.prefix} ${styles.simple}`}>
          {prefix}
        </div>
      );
    }

    return null;
  }

  renderSuffix(suffix, suffixValue) {

    if (Array.isArray(suffix)) {
      return (
        <Select
          className={`${styles.suffix} ${styles.select}`}
          name='suffix'
          value={suffixValue}
          options={suffix}
          onChange={this.handleChange('suffix')}
          clearable={false}
          searchable={false}
        />
      );
    }

    if (suffix) {
      return (
        <div className={`${styles.suffix} ${styles.simple}`}>
          {suffix}
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      border,
      children,
      className,
      label,
      value,
      prefix,
      prefixValue,
      suffix,
      suffixValue,
      style,
      inputStyle,
      ...inputProps
    } = this.props;
    const inputStyles = [styles.input];

    if (border) {
      inputStyles.push(styles.hasBorder);
    }

    // Set the initial state of the input so the parent can receive all of the props
    this.values = {
      prefix: prefixValue,
      suffix: suffixValue,
      input: value
    };

    // TODO: point the label to the main input without wrapping the entire container (because prefix and suffix)
    return (
      <div className={`${styles.inputContainer} ${className}`} style={style}>
        <label>{label || children}</label>
        <div className={inputStyles.join(' ')}>
          {this.renderPrefix(prefix)}
          <input
            {...inputProps}
            value={value}
            onChange={this.handleChange('input')}
            style={inputStyle}
          />
          {this.renderSuffix(suffix, suffixValue)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Input/index.jsx